var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail__group"},[_c('div',{staticClass:"detail__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('div',{staticClass:"detail__value"},[_vm._v(" "+_vm._s(_vm.value)+" ")]),_vm._t("extra-value")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }